import request from '@/util/http';

export default {
  authList,      //获取所有权限列表
  addAuth,       //添加顶级权限
  editAuthName,  //修改顶级权限
  authListRole,  //分配权限时的权限列表
}

//接口文件呢，post请求参数名为data，get请求参数名为params
function authList(data) {
  return request({
    url: 'sys/api/getallpermission',
    method: 'post',
    data
  })
}

function authListRole(data) {
  return request({
    url: 'sys/api/getuserpermission',
    method: 'post',
    data
  })
}

function addAuth(data) {
  return request({
    url: 'sys/api/addupdatepermission',
    method: 'post',
    data
  })
}

function editAuthName(data) {
  return request({
    url: "sys/api/addupdatepermission",
    method: 'post',
    data
  })
}